// extracted by css-extract-rspack-plugin
export default {"shortcutSelected":"rYWo0","shortcut":"bplO4","sectionLine":"VoBsg","sectionLabel":"YKCb0"};